// src/components/MainMenu.jsx

import React from "react";
import { NavLink } from "react-router-dom";
import LogoutButton from "./LogoutButton";
import "./MainMenu.css";

export default function MainMenu() {
  /* ============================================================
     GET LOGIN ROLE
  ============================================================ */

  const role = String(
    localStorage.getItem("userRole") || ""
  )
    .trim()
    .toLowerCase();

  /* ============================================================
     ROLE CHECKS
  ============================================================ */

  const isDoctor =
    role === "doctor";

  const isAdmin =
    role === "admin";

  const isReception =
    role === "reception";

  const isNursing =
    role === "nursing station";

  /*
    Doctor and Admin have full access.
  */

  const isFullAccess =
    isDoctor || isAdmin;

  /* ============================================================
     MENU PERMISSIONS

     DOCTOR
     -------
     Dashboard
     Patient Info
     Queue Status
     Consultation
     Patient History
     Manage

     ADMIN
     -----
     Dashboard
     Patient Info
     Queue Status
     Consultation
     Patient History
     Manage

     RECEPTION
     ---------
     Dashboard
     Patient Info
     Queue Status

     NURSING STATION
     ---------------
     Dashboard
     Queue Status
  ============================================================ */

  const showDashboard = true;

  const showPatientInfo =
    isFullAccess ||
    isReception;

  const showQueueStatus =
    isFullAccess ||
    isReception ||
    isNursing;

  const showConsultation =
    isFullAccess;

  const showPatientHistory =
    isFullAccess;

  const showManage =
    isFullAccess;

  return (
    <div
      className="main-menu-wrapper"
      style={{
        minHeight: "80vh",
        height: "auto",
        overflowY: "auto",
        padding: "25px",
        paddingBottom: "120px",
      }}
    >
      <div className="main-menu-container">

        {/* =====================================================
            DASHBOARD
        ===================================================== */}

        {showDashboard && (
          <NavLink
            to="/dashboard"
            className={({ isActive }) =>
              `main-menu-card ${isActive ? "active" : ""
              }`
            }
          >
            <div className="menu-icon dashboard-icon">
              <i className="fa fa-tachometer"></i>
            </div>

            <div className="menu-info">
              <span className="menu-small-title">
                Overview
              </span>

              <span className="menu-title">
                Dashboard
              </span>
            </div>

            <div className="menu-arrow">
              <i className="fa fa-angle-right"></i>
            </div>
          </NavLink>
        )}


        {/* =====================================================
            PATIENT INFO

            Doctor
            Admin
            Reception
        ===================================================== */}

        {showPatientInfo && (
          <NavLink
            to="/newprofile"
            className={({ isActive }) =>
              `main-menu-card ${isActive ? "active" : ""
              }`
            }
          >
            <div className="menu-icon patient-icon">
              <i className="fa fa-address-book-o"></i>
            </div>

            <div className="menu-info">
              <span className="menu-small-title">
                Management
              </span>

              <span className="menu-title">
                Patient Info
              </span>
            </div>

            <div className="menu-arrow">
              <i className="fa fa-angle-right"></i>
            </div>
          </NavLink>
        )}


        {/* =====================================================
            QUEUE STATUS

            Doctor
            Admin
            Reception
            Nursing Station
        ===================================================== */}

        {showQueueStatus && (
          <NavLink
            to="/doctor-queue"
            className={({ isActive }) =>
              `main-menu-card ${isActive ? "active" : ""
              }`
            }
          >
            <div className="menu-icon queue-icon">
              <i className="fa fa-users"></i>
            </div>

            <div className="menu-info">
              <span className="menu-small-title">
                Management
              </span>

              <span className="menu-title">
                Queue Status
              </span>
            </div>

            <div className="menu-arrow">
              <i className="fa fa-angle-right"></i>
            </div>
          </NavLink>
        )}


        {/* =====================================================
            CONSULTATION

            Doctor + Admin
        ===================================================== */}

        {showConsultation && (
          <NavLink
            to="/doctor"
            className={({ isActive }) =>
              `main-menu-card ${isActive ? "active" : ""
              }`
            }
          >
            <div className="menu-icon consult-icon">
              <i className="fa fa-stethoscope"></i>
            </div>

            <div className="menu-info">
              <span className="menu-small-title">
                Management
              </span>

              <span className="menu-title">
                Consultation
              </span>
            </div>

            <div className="menu-arrow">
              <i className="fa fa-angle-right"></i>
            </div>
          </NavLink>
        )}


        {/* =====================================================
            PATIENT HISTORY

            Doctor + Admin
        ===================================================== */}

        {showPatientHistory && (
          <NavLink
            to="/history"
            className={({ isActive }) =>
              `main-menu-card ${isActive ? "active" : ""
              }`
            }
          >
            <div className="menu-icon visit-icon">
              <i className="fa fa-address-card-o"></i>
            </div>

            <div className="menu-info">
              <span className="menu-small-title">
                Records
              </span>

              <span className="menu-title">
                Patient History
              </span>
            </div>

            <div className="menu-arrow">
              <i className="fa fa-angle-right"></i>
            </div>
          </NavLink>
        )}

        <NavLink
          to="/procedure"
          className={({ isActive }) =>
            `main-menu-card ${isActive ? "active" : ""}`
          }
        >
          <div className="menu-icon proc-icon">
            <i class="fa fa-medkit"></i>
          </div>

          <div className="menu-info">
            <span className="menu-small-title">Follow-up</span>
            <span className="menu-title">Procedure</span>
          </div>

          <div className="menu-arrow">
            <i className="fa fa-angle-right"></i>
          </div>
        </NavLink>


        {/* =====================================================
            MANAGE

            STRICTLY:
            Doctor + Admin ONLY
        ===================================================== */}

        {/* {showManage && (
          <NavLink
            to="/manage"
            className={({ isActive }) =>
              `main-menu-card ${isActive ? "active" : ""
              }`
            }
          >
            <div className="menu-icon sett-icon">
              <i className="fa fa-cogs"></i>
            </div>

            <div className="menu-info">
              <span className="menu-small-title">
                Administration
              </span>

              <span className="menu-title">
                Manage
              </span>
            </div>

            <div className="menu-arrow">
              <i className="fa fa-angle-right"></i>
            </div>
          </NavLink>
        )} */}


        {/* =====================================================
            LOGOUT
        ===================================================== */}

        {/* <LogoutButton
          className="
            main-menu-card
            logout-card
            menu-logout-button
          "
        /> */}

      </div>
    </div>
  );
}